import { createSelector } from '@reduxjs/toolkit';
import { nutritionistTestOptionsAdapter } from '../state/nutritionist-test.slice';

export const nutritionistTestSearchTextSelector = state =>
  state.wnNutritionistTest.searchTextCriteria;

export const nutritionistTestModalitiesSelector = state =>
  state.wnNutritionistTest.modalityCriteria;

export const { selectAll } = nutritionistTestOptionsAdapter.getSelectors(
  state => state.wnNutritionistTest.testOptions,
);

export const nutritionistTestCurrentStepSelector = state =>
  state.wnNutritionistTest.currentStep;

export const nutritionistTestIsSearchingByTextSelector = state =>
  state.wnNutritionistTest.isSearchingByText;

export const nutritionistTestOptionsSelector = createSelector(
  [selectAll],
  testOptions => {
    const baseState = {
      step1: [],
      step2: [],
      step3: [],
      step4: [],
      step5: [],
      general: [],
    };

    return testOptions
      .map((option, index, testOptions) => {
        return {
          ...option,
          childOptions: option.childOptions
            .map(optionKey => {
              const mappedOption = testOptions.find(
                option => option.key === optionKey,
              );
              return mappedOption || '';
            })
            .filter(option => option !== ''),
        };
      })
      .reduce((accumulator, option) => {
        const { key } = option;
        const [stepKey = ''] = key.split('-');
        const step = {
          q0: 'step1',
          q2: 'step2',
          q3: 'step3',
          q4: 'step4',
          q5: 'step5',
        }[stepKey];

        if (step) {
          accumulator[step] = [...accumulator[step], option];
        } else {
          accumulator.general = [...accumulator.general, option];
        }

        return accumulator;
      }, baseState);
  },
);

export const nutritionistTestTargetSelector = createSelector(
  [state => state.wnNutritionistTest.target, selectAll],
  (target, testOptions) => {
    return {
      ...target,
      childOptions: target.childOptions
        .map(optionKey => {
          const mappedOption = testOptions.find(
            option => option.key === optionKey,
          );
          return mappedOption || '';
        })
        .filter(option => option !== ''),
    };
  },
);
